<div class="modal-header">
    <h4 class="modal-title pull-left">Dealstate Parser</h4>
    <div aria-label="Close" (click)="onCancel()" class="close pull-right">
        <span aria-hidden="true">×</span>
    </div>
</div>

<div class="modal-body upload-file">
    <loader [loading]="loading"></loader>
    <!-- Success Message -->
    <div *ngIf="isSuccess" class="alert alert-success">
        <div>File uploaded successfully!</div>
        <div *ngIf="importSummary" class="mt-2 small">
            <div><strong>{{ importSummary.total }}</strong> row(s) processed</div>
            <div><strong>{{ importSummary.inserted }}</strong> added &middot;
                 <strong>{{ importSummary.updated }}</strong> updated</div>
            <div *ngIf="importSummary.failed > 0" class="text-danger">
                <strong>{{ importSummary.failed }}</strong> failed to import
            </div>
        </div>
    </div>
    <!-- Error Message -->
    <div *ngIf="isError" class="alert alert-danger">
        {{ errorMessage }}
    </div>

    <!-- Radio buttons for Version 1 and Version 2 -->
    <div *ngIf="!isSuccess && !loading" class="form-group d-flex justify-content-center align-items-center mb-4">
        <label class="mr-3">
            <input type="radio" name="version" [(ngModel)]="selectedVersion" value="version1" /> Version 1
        </label>
        <label class="ml-3">
            <input type="radio" name="version" [(ngModel)]="selectedVersion" value="version2" /> Version 2
        </label>
        <label class="ml-3">
            <input type="radio" name="version" [(ngModel)]="selectedVersion" value="version3" /> Version 3
        </label>
    </div>

    <ngx-file-drop *ngIf="!isSuccess && !loading && selectedVersion" dropZoneLabel="Drop files here"
        (onFileDrop)="fileDropped($event)" multiple="false" dropZoneLabel="Drag & Drop File">
        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
            <a class="pick-file" (click)="openFileSelector()">
                <div class="d-block">
                    <div class="text-center">Drag & Drop File here</div>
                    <div class="text-center">Or Pick by Clicking</div>
                </div>
            </a>
        </ng-template>
    </ngx-file-drop>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
</div>